import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose, setDisplayName, setPropTypes } from 'recompose';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { switchBreakpoint as switchBreakpointAction } from '../actions/breakpoint';

function withBreakpoint(WrappedComponent) {
  const wrappedComponentName = WrappedComponent.displayName
        || WrappedComponent.name
        || 'Component';

  class WithBreakpoint extends Component {
    componentDidMount() {
      global.addEventListener('rpBreakpointsSwitch', this.handleSwitchBreakpoint);
    }

    componentWillUnmount() {
      global.removeEventListener('rpBreakpointsSwitch', this.handleSwitchBreakpoint);
    }

    handleSwitchBreakpoint = (event) => {
      const { switchBreakpoint } = this.props;
      switchBreakpoint(event.detail);
    };

    render() {
      return (
        <WrappedComponent {...this.props} />
      );
    }
  }

  const mapStateToProps = ({ breakpoint }) => ({ breakpoint: breakpoint.current.code });

  const mapDispatchToProps = dispatch => (
    bindActionCreators({ switchBreakpoint: switchBreakpointAction }, dispatch)
  );

  return compose(
    setDisplayName(`WithBreakpoint(${wrappedComponentName})`),
    connect(mapStateToProps, mapDispatchToProps),
    setPropTypes({
      switchBreakpoint: PropTypes.func.isRequired,
    }),
  )(WithBreakpoint);
}

export default withBreakpoint;
